// @ts-nocheck
const ChatsSkeleton = () => {

    return (
        <div>Es lädt...</div>
    )
}

export default ChatsSkeleton